exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control.ng-valid[required] {\n  border-left: 5px solid #42A948;\n}\n\n.form-control.ng-invalid.ng-dirty,\n.form-control.ng-invalid.ng-touched {\n  border-left: 5px solid #a94442;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/questions/questions-details/questions-details.component.css
// module id = ../../../../../src/app/modules/questions/questions-details/questions-details.component.css
// module chunks = main